import { RELEVANCY_DATA_SOURCES } from '../../../types/relevancyData';
import { USER_PERSONA_RELEVANCY_DATA } from '../../../constants/recommendations/UserPersonaRelevancyData';
export const getRelevancyDataFromDerivedPersonas = surveyData => {
  const {
    user: userData
  } = surveyData;
  const {
    assignedPersona
  } = userData;
  // TODO: handle multiple personas
  const firstPersona = assignedPersona === null || assignedPersona === void 0 ? void 0 : assignedPersona[0];
  const relevancyData = firstPersona ? USER_PERSONA_RELEVANCY_DATA[firstPersona] : null;
  if (!relevancyData) {
    return null;
  }
  return Object.assign({
    dataSource: RELEVANCY_DATA_SOURCES.DERIVED_PERSONAS
  }, relevancyData);
};